import { render, staticRenderFns } from "./PrintPageContentButton.vue?vue&type=template&id=f22d38bc&"
import script from "./PrintPageContentButton.vue?vue&type=script&lang=js&"
export * from "./PrintPageContentButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports